// soundHandler.js
var SoundHandler = pc.createScript('soundHandler');

SoundHandler.attributes.add('numberTracks', {type:'number'});
SoundHandler.attributes.add('trackUrl', {type:'string'});
SoundHandler.attributes.add('numberNoises', {type:'number'});
SoundHandler.attributes.add('noiseUrl', {type:'string'});
SoundHandler.attributes.add('cam', {type:'entity'});
SoundHandler.attributes.add('planetNoise', {type:'entity'});


// initialize code called once per entity
SoundHandler.prototype.initialize = function() {
    
    this.seedScript = this.app.root.findByName('SEEDER').script.seeder;
    this.theSeed = 0.0;
    this.randomize = 0.0;
    this.planetNoise.enabled = false;
    this.app.on('solarSystem:allPlanets', this.setMusic, this);
   // this.app.on('systemGenerator:reset', this.reset, this);
    this.app.on('uiGenerator:stopMusic', this.stopMusic, this);
    this.app.on('uiGenerator:playPlanetSound', this.playPlanetSound,this);
    this.app.on('uiGenerator:stopPlanetSound', this.stopSound, this);
    this.app.on('userInput:test',this.checkNoise, this); 
    //ausgemacht kp warum es geht - weg. planet noise
   // this.app.on('userInput:objectSelected', this.changePlanetSound, this);
    this.entity.element.on('click', this.up, this);
    this.music = this.cam.sound;
    this.activeMarker = this.entity.children[0];
    this.playing = false;
    this.switcher = -1;
    this.track = null;
    this.counter = 0;
    this.newChannel = 'channel_2';
    this.oldChannel = 'channel_1';
    this.channelSwitch = 1;
    this.fadingOut = false;
    this.callBackFade = false;
    this.fadeInTween = null;
    this.fadeOutTween = null;
    this.planetInverter = -1;
    this.newPlanet = null;
    this.oldPlanet = null;
    this.soundPlaying = false;
    this.noisePlaying = false;
    this.wasPlaying = false;
    this.fadeBackTween = null;
    this.xFadeTween = null;
    this.planetName = this.app.root.findByName('planetNumberTag');
    this.isLoading = false;
    
    this.btn = this.app.root.findByName('buttonAdUI8');
    
    this.music.addSlot('channel_1', {
        loop: true,
        autoPlay: false,
        asset: null
    });  
    
    this.music.addSlot('channel_2', {
        loop: true,
        autoPlay: false,
        asset: null
    });  
    
    this.music.addSlot('channel_3', {
        loop: true,
        autoPlay: false,
        asset: null
    });  
    
    this.music.addSlot('channel_4', {
        loop: true,
        autoPlay: false,
        asset: null
    });  
        
    this.music.addSlot('planetNoise', {
        loop: true,
        autoPlay: false,
        asset: null,
        volume: 1,
        pitch: 0.15
    });  
    
    this.up();
};

SoundHandler.prototype.up = function() {

    if(!this.playing && this.switcher > 0){
        this.switcher = -1;
    }
       
    if(this.switcher > 0){
        this.playing = false;
        this.wasPlaying = false;
        this.activeMarker.enabled = false;
        if(this.fadeInTween){
            this.fadeInTween.stop();
        }
        this.fadeOut();
    } else {
        this.playing = true;
        this.activeMarker.enabled = true;
        if(this.wasPlaying){
            this.music.resume(this.newChannel);
        } else {
            this.music.play(this.newChannel);
        }
        
        if(this.fadeOutTween){ 
            this.fadeOutTween.stop();
        }
        
        this.fadeIn();
    }
    
    
};


SoundHandler.prototype.setMusic = function() {
    
   // console.log('isloading: ' + this.isLoading);
    if(this.isLoading){
        return;
    } else {
        this.isLoading = true;
    }
    
    if(this.channelSwitch > 0){
       // console.log('switchChannel 2');
        this.newChannel = 'channel_2';
        this.oldChannel = 'channel_1';
    } else if(this.channelSwitch < 0 ){
       // console.log('switchChannel 1');
        this.newChannel = 'channel_1';
        this.oldChannel = 'channel_2';
    }
    
    if(!this.playing){
        this.channelSwitch *= -1;
    }
    
    this.counter += 1;
    var that = this;
    var rnd = Math.floor(Math.random()*this.numberTracks);
    if(rnd === 0){
        rnd = 1;
    } 

    var trckNm = this.trackUrl + '/planet_' + rnd + '.mp3';
    var trck = null;
    //console.log(trckNm);

    this.app.assets.loadFromUrl(trckNm, 'audio', function (err, asset) {
        that.isLoading = true;
        that.waitForLoading(asset);
    });    
    
};


SoundHandler.prototype.waitForLoading = function(ass){
    self = this;    
    ass.ready(function (ass) {
        self.attachAndPlay(ass);
    }); 
    
};

SoundHandler.prototype.attachAndPlay = function(ass) {
//     if(this.planetInverter > 0){
//         console.log('newplanet_1');
//         this.newPlanet = 'channel_1';
//         this.oldPlanet = 'channel_2';
        
//     } else if(this.planetInverter < 0) {
//         console.log('newplanet_2');
//         this.newPlanet = 'channel_2';
//         this.oldPlanet = 'channel_1';
    
//     }


    this.music.slot(this.newChannel).asset = ass;
    //console.log('NEWCHANNEL: ' + this.music.slot(this.newChannel).asset);
    //console.log('OLDCHANNEL: ' + this.music.slot(this.oldChannel).asset);
    // if(this.fadingOut){
    //     this.callBackFade = true;
    // } else {
    //     this.fadeIn(this.newChannel);
    // }    
    if(this.playing){
        this.crossFadePlanets();
    } else {
     if(this.fadingOut){
         this.callBackFade = true;
     } else {
         this.fadeIn(this.newChannel);
     }
    }
    
};


SoundHandler.prototype.checkNoise = function(){
    
  if(this.noisePlaying){
      //this.app.fire('hoverClick:clicked', this.btn);
      this.fadeOutNoise();
      
  }  
};


SoundHandler.prototype.fadeIn = function() {
    
    this.switcher *= -1;
    if(this.noisePlaying){
        this.app.fire('hoverClick:clicked', this.btn);
        this.stopSound();
    }

    var here = this;
    
    if(this.music.slot(here.newChannel) === undefined){
        return;
    }
    
    this.music.slot(here.newChannel).volume = 0;
    if(this.playing){
        this.music.volume = 0.3;
        if(!this.wasPlaying){
            this.music.play(this.newChannel);
        }
      
        var vl = {tVolume:0};
        this.fadeInTween = this.entity.tween(vl).to({tVolume:0.3}, 1.5, pc.Linear).on('update', function(){
            here.music.slot(here.newChannel).volume = vl.tVolume;
        }).on('complete', function(){
            here.isLoading = false;
        }).start();
    }
    
};

SoundHandler.prototype.fadeOut = function() {
   // console.log('FADEOUT');
    this.switcher *= -1;
    if(this.music.slot(this.newChannel) === undefined){
        return;
    }
    
    this.fadingOut = true;
    var there = this;
 
        
        var vl = {tVolume:this.music.slot(this.newChannel).volume};
        this.fadeOutTween = this.entity.tween(vl).to({tVolume:0}, 1.5, pc.Linear).on('update', function(){
            there.music.slot(there.newChannel).volume = vl.tVolume;
        }).on('complete', function(){
            if(there.wasPlaying){
               // console.log('pause');
                there.music.slot(there.newChannel).pause();
            } else {
              //  console.log('stop');
                if(!there.fadeBack){
                    there.music.slot(there.newChannel).stop();
                }
                there.switcher *= -1;
            }
            there.fadingOut = false;
            if(there.callBackFade){
                there.fadeIn();
                there.callBackFade = false;
            }
        }).start();
    

    
};

// SoundHandler.prototype.changePlanetSound = function() {
//     console.log('CHANGESOUND');
//     var scp = this;
    
//     if(this.planetInverter > 0){
        
//         this.newPlanet = 'channel_3';
//         this.oldPlanet = 'channel_4';
        
//     } else if(this.planetInverter < 0) {
        
//         this.newPlanet = 'channel_4';
//         this.oldPlanet = 'channel_3';
        
//     }
    
// //     var prnd = Math.floor(Math.random()*this.numberNoises);
// //     var noiseURL = 'https://www.rtz23.de/science/pocketUniverse/audio/planetNoises/test/';
    
// //     if(prnd === 0){
// //         prnd = 1;
// //     } 
// //     var ptrckNm = noiseURL + prnd + '.mp3';
// //     var ptrck = null;
    
//     console.log('CHANGESOUND');
//     this.app.assets.loadFromUrl(ptrckNm, 'audio', function (err, asset) {
//         scp.readyFunction(asset);
//     });        
// };

// SoundHandler.prototype.readyFunction = function(ass){
//     console.log('READYFUNCTION');
//     var rf = this;
//     ass.ready(function (ass) {
//         rf.waitForNewPlanet(ass);
//     });
// };

// SoundHandler.prototype.waitForNewPlanet = function(ass) {
//     console.log('WAITFORNEWPLANET');

//     this.music.slot(this.newPlanet).asset = ass;
//    // this.music.slot(this.newPlanet).volume = 0;
//     this.music.play(this.newPlanet);
//     this.crossFadePlanets();
// };


SoundHandler.prototype.crossFadePlanets = function() {
   // console.log('CROSSFADE');
    this.channelSwitch *= -1;
    var scope = this;
    if(this.music.slot(this.newChannel) === undefined){
        return;
    }
    

    this.music.slot(this.newChannel).play();
    //this.music.slot(this.oldPlanet).resume();

    var vol = {in:0, out:0.3};
    this.xFadeTween = this.entity.tween(vol).to({in:0.3, out:0}, 3, pc.Linear).on('update', function(){
       // console.info(vol);
        scope.music.slot(scope.newChannel).volume = vol.in;
        scope.music.slot(scope.oldChannel).volume = vol.out;
        //console.log('new: ' + scope.music.slot(scope.newChannel).volume + ' old: ' + scope.music.slot(scope.oldCHannel).volume);
    }).on('complete', function(){
            scope.isLoading = false;
    }).start();   
    
    this.planetInverter *= -1;

};

SoundHandler.prototype.stopMusic = function(){
  //  console.log('STOPMUSIC');
    
    this.noisePlaying = true;
    if(this.fadeNoiseTween){
        this.fadeNoiseTween.stop();
    }
    
    if(this.xFadeTween){
        this.xFadeTween.stop();
    }
    
    if(this.fadeBackTween){
        this.fadeBackTween.stop();
    }
    
    if(this.fadeInTween){
        this.fadeInTween.stop();
    }
    
    if(this.playing) {
        this.wasPlaying = true;
        this.switcher *= -1;
        this.playing = false;
    }
    
    this.activeMarker.enabled = false;
    
    this.fadeOut();
    
};

SoundHandler.prototype.stopSound = function(){
    //console.log('STOPSOUND');
    this.planetNoise.enabled = false;

    if(this.noisePlaying){
        if(this.fadeNoiseTween){
            this.fadeNoiseTween.stop();
        }
        this.fadeOutNoise();        
    } else {
        return;
    }
    
    if(this.playing) {
        this.switcher *= -1;
    }
    
    if(this.wasPlaying){
        this.wasPlaying = false;
      //  console.log('RESUMESOUND');
        this.music.slot(this.newChannel).resume();
        this.fadeBack();
    } 
        
};

SoundHandler.prototype.fadeBack = function(){
    
  //  console.log('FADEBACKSTARTET');

    this.activeMarker.enabled = true;
    this.playing = true;
    var dis = this;
    var aud = {vl:this.music.slot(this.newChannel).volume}; //
    this.fadeBackTween = this.entity.tween(aud).to({vl:0.3}, 1.5, pc.Linear).on('update', function(){
        dis.music.slot(dis.newChannel).volume = aud.vl;
        //console.log(dis.music.slot(dis.newChannel).volume);
    }).on('complete', function(){
       // console.log('FADEBACK COMPLETE');
    }).start();
    
};


SoundHandler.prototype.playPlanetSound = function(cls){
    
    var that = this;
    var name = this.planetName.element.text;
    this.randomize = new Math.seedrandom(name);
    this.planetNoise.enabled = true;
    var noiseUrlBase = 'https://www.rtz23.de/science/pocketUniverse/audio/planetNoises/';
    var planetClass = cls;
    var urlFolder = null;
    var fileName = null;
    var soundUrl = null;
    
    var rndPick = Math.floor(this.randomize()*this.numberNoises);
    
    
    if(rndPick === 0){rndPick = 1;}
   // console.log('PLANETCLASS**************');
   // console.log('rndPick: ' + rndPick);
   // console.info(planetClass);
    urlFolder = planetClass.name;
    
    if(planetClass.name == 'system'){
        urlFolder = 'system';
        fileName =  '/dyson_' + rndPick + '.mp3';
       // console.log('sun');
    } else if(planetClass.name == 'habitable'){
        urlFolder = 'rockPlanet';
        fileName =  '/rocky_' + rndPick + '.mp3';
       // console.log('habitable');
    } else if(planetClass.name == 'rockPlanet'){
        urlFolder = 'rockPlanet';
        fileName =  '/rocky_' + rndPick + '.mp3';
       // console.log('rockPlanet');
    } else if(planetClass.name == 'gasGiant'){
        urlFolder = 'gasGiant';
        fileName =  '/gasgiant_' + rndPick + '.mp3';
       // console.log('gasGiant');
    }
    
    soundUrl = noiseUrlBase + urlFolder + fileName;
        
    this.app.assets.loadFromUrl(soundUrl, 'audio', function (err, asset) {
        that.waitForNoise(asset);
    }); 
    
    
};

SoundHandler.prototype.waitForNoise = function(ass){
    var rf = this;
    ass.ready(function (ass) {
        rf.attachAndPlayNoise(ass);
    });
};

SoundHandler.prototype.attachAndPlayNoise = function(ass){
    
    this.music.slot('planetNoise').asset = ass;
    this.music.slot('planetNoise').play(ass);
    //this.playing = true;
    this.fadeInNoise();
};


SoundHandler.prototype.fadeInNoise = function() {
    this.noisePlaying = true;
    var fiscp = this;

        this.music.slot('planetNoise').volume = 0;
        var vl = {tVolume:0};
       // console.info(fiscp.music);
        this.fadeNoiseTween = this.entity.tween(vl).to({tVolume:1}, 1.5, pc.Linear).on('update', function(){
            fiscp.cam.sound.slot('planetNoise').volume = vl.tVolume;
        }).start();

    
};

SoundHandler.prototype.fadeOutNoise = function() {
  // console.log('FADEOUTNOISE');
    var foscp = this;
        //this.music.slot('planetNoise').volume = 0.5;
        var vl = {tVolume:this.music.slot('planetNoise').volume};
        
  
        this.fadeNoiseTween = this.entity.tween(vl).to({tVolume:0}, 1.5, pc.Linear).on('update', function(){
            foscp.cam.sound.slot('planetNoise').volume = vl.tVolume;
        }).on('complete', function(){
            foscp.noisePlaying = false;
        })
            .start();

    
};

SoundHandler.prototype.reset = function() {
   
};


// update code called every frame
SoundHandler.prototype.update = function(dt) {

};

// swap method called for script hot-reloading
// inherit your script state here
// SoundHandler.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// https://developer.playcanvas.com/en/user-manual/scripting/

